import { parserMetadatasFilter } from 'components/filters/MetadatasFilterTemplate/utils/parserMetadatasFilter'
import { CitizenFilterKeyString } from 'CitizenProfile/types'
import { ActivityType } from 'Activities/types'
import { Place } from 'Geo/types'
import { removeEverythingThatIsNotNumber } from 'utils/transforms/string'
import { parserActivitiesTypesNamesForIdsFromKey } from 'components/filters/FrequencieActivitiesTypesFilterTemplate/utils/parserActivitiesTypesNamesForIdsFromKey'
import { americanDateParser } from 'utils/parsers/date'

type Params = {
  filter: any
  activitiesTypes?: ActivityType[]
  places?: Place[]
}

function parserActivityTypeNameForId(filter: CitizenFilterKeyString, activitiesTypes: ActivityType[]) {
  const [activityType] = activitiesTypes.filter(({ name }) => {
    return filter.activity_type_name === name
  })
  if (activityType) {
    filter.activity_type_id = activityType.id
    delete filter.activity_type_name
  }
  return filter
}

function parserPlaceNameForId(filter: CitizenFilterKeyString, places: Place[]) {
  const [place] = places.filter(({ place_name }) => {
    return filter.place_name === place_name
  })
  if (place) {
    filter.place_id = place.place_id
    delete filter.place_name
  }
  return filter
}

function removeAllThatIsNotNumberFromField(filter: CitizenFilterKeyString, key: string) {
  if (filter[key]) filter[key] = removeEverythingThatIsNotNumber(filter[key] as string)
}

export function parserCitizenFilter(params: Params) {
  const { activitiesTypes, filter, places } = params
  let formatedFilter = { ...filter }
  if (formatedFilter.birth_certificate_date) {
    formatedFilter.birth_certificate_date = americanDateParser(filter.birth_certificate_date)
  }
  if (activitiesTypes) formatedFilter = parserActivityTypeNameForId(formatedFilter, activitiesTypes)
  if (places) formatedFilter = parserPlaceNameForId(formatedFilter, places)
  if (activitiesTypes)
    formatedFilter = parserActivitiesTypesNamesForIdsFromKey('has_activities_types', formatedFilter, activitiesTypes)
  if (activitiesTypes)
    formatedFilter = parserActivitiesTypesNamesForIdsFromKey(
      'not_has_activities_types',
      formatedFilter,
      activitiesTypes
    )
  formatedFilter = parserMetadatasFilter(formatedFilter)
  removeAllThatIsNotNumberFromField(formatedFilter, 'cpf_number')
  removeAllThatIsNotNumberFromField(formatedFilter, 'unified_person_cpf_number')
  removeAllThatIsNotNumberFromField(formatedFilter, 'cns_number')
  removeAllThatIsNotNumberFromField(formatedFilter, 'unified_person_cns_number')
  removeAllThatIsNotNumberFromField(formatedFilter, 'ctps_pis_number')
  removeAllThatIsNotNumberFromField(formatedFilter, 'unified_person_ctps_pis_number')
  removeAllThatIsNotNumberFromField(formatedFilter, 'rg_number')
  removeAllThatIsNotNumberFromField(formatedFilter, 'unified_person_rg_number')
  return formatedFilter
}
